import React from 'react';

const English = (props) => (
	<img src="https://flagsapi.com/GB/flat/64.png" width={40} height={'auto'} />
);

export default English;


